<template>
  <div>
    <div
      class="guestbook-navigation"
      :class="{ responsive: isActive }"
      :style="{ backgroundColor: this.nav.bgColor }"
    >
      <div class="guestbook-navigation__header">
        <div class="guestbook-navigation__header__language-container">
          <button
            v-show="false"
            v-if="isLanguageSecond"
            :style="{
              backgroundColor: this.nav.bgColor,
              borderColor: this.nav.textColor,
              color: this.nav.textColor,
            }"
          >
            <p>{{ selectedLanguageIso }}</p>
            <v-icon
              name="caret-down"
              scale="1"
              :style="{ color: this.nav.textColor }"
            ></v-icon>
            <div
              class="guestbook-navigation__header__language-container__dropdown"
            >
              <div
                class="guestbook-navigation__header__language-container__dropdown__button-container"
              >
                <input
                  type="radio"
                  name="language"
                  :checked="!isLanguageSecondActive"
                />
                <span class="radio-button-custom">
                  <span
                    class="radio-button-custom__checkmark"
                    :style="{ backgroundColor: this.nav.bgColor }"
                  ></span>
                </span>
                <p>{{ languageNativeNameDefault }}</p>
              </div>
              <div
                class="guestbook-navigation__header__language-container__dropdown__button-container"
              >
                <input
                  type="radio"
                  name="language"
                  :checked="isLanguageSecondActive"
                />
                <span class="radio-button-custom">
                  <span
                    class="radio-button-custom__checkmark"
                    :style="{ backgroundColor: this.nav.bgColor }"
                  ></span>
                </span>
                <p>{{ languageNativeNameSecond }}</p>
              </div>
            </div>
          </button>
        </div>
        <div class="guestbook-navigation__header__logo-container">
          <div class="expander"></div>
          <img v-bind:src="this.nav.logoPath" />
        </div>
        <div
          v-if="links && links.length"
          class="guestbook-navigation__header__nav-button-container"
          :style="{ color: this.nav.textColor }"
          @click="toggleNavigationActive"
        >
          <div class="hamburger-icon">
            <span
              class="hamburger-icon__bar"
              :style="{ backgroundColor: this.nav.textColor }"
            ></span>
            <span
              class="hamburger-icon__bar"
              :style="{ backgroundColor: this.nav.textColor }"
            ></span>
            <span
              class="hamburger-icon__bar"
              :style="{ backgroundColor: this.nav.textColor }"
            ></span>
          </div>
        </div>
      </div>
      <div class="guestbook-navigation__navigation" v-if="isNavigationActive">
        <div class="guestbook-navigation__navigation__wrapper">
          <div
            class="guestbook-navigation__navigation__item"
            v-for="link in links"
            :key="link.path"
            @click="routerPush(link.path)"
          >
            <!-- <span v-if="isLanguageSecond && languageCookie">{{link.textSec}}</span>
            <span v-else>{{link.text}}</span> -->
            <span>{{ link.text }}</span>
          </div>
        </div>
      </div>
      <div v-on:click="editMenu()" class="editIcon">
        <v-icon class="innerIcon" name="pencil-alt" scale="1.5"></v-icon>
      </div>
    </div>

    <transition name="fadeInModal">
      <navigation-edit
        v-bind:style="{ zIndex: '99' }"
        v-show="isModalVisible"
        @close="closeModal"
        :pagesOverview="pagesOverview"
      ></navigation-edit>
    </transition>
  </div>
</template>

<script>
import NavigationEdit from "./GuestbookNavigationEdit/NavigationEdit";
import bus from "@/bus";
import config from "../../../config";

export default {
  components: {
    NavigationEdit,
  },
  props: {
    links: Array,
    nav: Object,
    pagesOverview: Object,
    cookieExists: String,
  },
  data() {
    return {
      isModalVisible: false,
      isActive: false,
      currentLanguageType: "",
      isLanguageSecond: false,
      isLanguageSecondActive: false,
      countryCodeDefault: "",
      countryCodeSecond: "",
      languageNativeNameDefault: "",
      languageNativeNameSecond: "",
      selectedLanguageIso: "",
      isNavigationActive: false,
    };
  },
  created() {
    bus.$on("languageChanged", () => {
      if (this.getCookie("secondLanguage")) {
        this.currentLanguageType = this.$settingsSecondLanguageType;
      } else {
        this.currentLanguageType = this.$settingsDefaultLanguageType;
      }
      console.log(this.currentLanguageType);
    });
  },
  computed: {
    hexToRgb() {
      var color = this.nav.textColor;
      var colorOpacity = this.nav.borderOpacity;
      color = color.replace("#", "");
      let r = parseInt(color.substring(0, 2), 16);
      let g = parseInt(color.substring(2, 4), 16);
      let b = parseInt(color.substring(4, 6), 16);
      let result =
        "rgba(" + r + "," + g + "," + b + "," + colorOpacity / 100 + ")";
      return result;
    },
  },
  mounted() {
    // this.fetchNavigationData();
  },
  methods: {
    myFunction: function () {
      if (this.isActive) {
        this.isActive = false;
      } else {
        this.isActive = true;
      }
    },
    routerPush: function (data) {
      window.open(`${config.hardcodedPath}${data}`, "_blank");
    },
    editMenu() {
      this.isModalVisible = true;
      bus.$emit("bodyOverflow", true);
    },
    closeModal() {
      this.isModalVisible = false;
      bus.$emit("bodyOverflow", false);
    },
    toggleNavigationActive() {
      this.isNavigationActive = !this.isNavigationActive;
    },
    fetchNavigationData() {
      if (this.$hotelId) {
        import("@/firebase")
          .then((modules) => {
            return modules.db;
          })
          .then((db) => {
            db.ref(`hotels/${this.$customerId}/${this.$hotelId}/hotelLanguages/languageTypes`)
              .once("value")
              .then((snapshot) => {
                let languageTypes = snapshot.val();
                this.isLanguageSecond = languageTypes.length > 1;
                this.countryCodeDefault = languageTypes[0];
                this.countryCodeSecond = languageTypes[1];

                if (this.isLanguageSecond) {
                  // Get native names
                  this.$http
                    .get(
                      `https://restcountries.com/v2/alpha/${this.countryCodeDefault}?fields=languages`
                    )
                    .then(
                      (response) =>
                        (this.languageNativeNameDefault =
                          response.data.languages[0].nativeName)
                    );
                  this.$http
                    .get(
                      `https://restcountries.com/v2/alpha/${this.countryCodeSecond}?fields=languages`
                    )
                    .then(
                      (response) => {
                        this.languageNativeNameSecond = response.data.languages[0].nativeName;
                        if(this.countryCodeSecond == 'PH') {
                          this.languageNativeNameSecond = 'Tagalog';
                        }
                      }
                    );

                  // Get ISO639 code of selected language
                  if (this.currentLanguageType === this.countryCodeSecond) {
                    this.$http
                      .get(
                        `https://restcountries.com/v2/alpha/${this.countryCodeSecond}?fields=languages`
                      )
                      .then(
                        (response) => {
                          this.selectedLanguageIso = response.data.languages[0].iso639_1;
                          if(this.countryCodeSecond == 'PH') {
                            this.selectedLanguageIso = 'PH';
                          }
                        }
                      );
                    this.isLanguageSecondActive = true;
                  } else {
                    // (this.currentLanguageType === this.countryCodeDefault || this.currentLanguageType === null)
                    this.$http
                      .get(
                        `https://restcountries.com/v2/alpha/${this.countryCodeDefault}?fields=languages`
                      )
                      .then(
                        (response) =>
                          (this.selectedLanguageIso =
                            response.data.languages[0].iso639_1)
                      );
                    this.isLanguageSecondActive = false;
                  }
                }
              });
          });
      }
    },
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}
/* [v-cloak] {display: none} */

.editIcon {
  width: 48px;
  height: 48px;
  position: absolute;
  top: 10px;
  left: 5px;
  padding: 10px 14px;
  border-radius: 50%;
  cursor: pointer;
  color: #fff;
  background-color: #3f3d39;
  min-height: 0px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

.guestbook-navigation {
  height: 70px;
  position: relative;
}
.guestbook-navigation__header,
.guestbook-navigation__header__language-container,
.guestbook-navigation__header__logo-container,
.guestbook-navigation__header__nav-button-container {
  /* all containers under main navigation */
  height: 100%;
}
.guestbook-navigation__header {
  max-width: 1000px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.guestbook-navigation__header__language-container,
.guestbook-navigation__header__nav-button-container {
  width: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.guestbook-navigation__header__language-container button {
  border: none;
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0;
  text-transform: uppercase;
}
.guestbook-navigation__header__language-container button p {
  display: inline-block;
  margin-right: 5px;
}
.guestbook-navigation__header__language-container__dropdown {
  display: none;
  position: absolute;
  z-index: 1;
  background-color: white;
  margin-left: 10px;
  border-radius: 8px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.25);
}
.guestbook-navigation__header__language-container__dropdown:before {
  content: "";
  position: absolute;
  z-index: -1;
  top: -6px;
  left: 15px;
  width: 12px;
  height: 12px;
  background-color: white;
  transform: rotate(45deg);
}
.guestbook-navigation__header__language-container__dropdown__button-container {
  display: flex;
  align-items: center;
  padding: 15px;
  background-color: white;
  color: #aaaaaa;
  text-transform: capitalize;
  text-align: left;
}
.guestbook-navigation__header__language-container__dropdown__button-container:first-child {
  border-radius: 8px 8px 0 0;
}
.guestbook-navigation__header__language-container__dropdown__button-container:last-child {
  border-radius: 0 0 8px 8px;
}
.guestbook-navigation__header__language-container__dropdown__button-container
  p {
  margin: 0;
}
.guestbook-navigation__header__language-container
  button:hover
  .guestbook-navigation__header__language-container__dropdown {
  display: block;
}
.guestbook-navigation__header__language-container__dropdown__button-container
  input {
  visibility: hidden;
  position: absolute; /* Do not take up space for other items */
}
.guestbook-navigation__header__language-container__dropdown__button-container
  .radio-button-custom {
  width: 25px;
  height: 25px;
  border: 4px solid #aaaaaa;
  border-radius: 50%;
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.guestbook-navigation__header__language-container__dropdown__button-container:hover {
  color: #999999;
  background-color: #eeeeee;
}
.guestbook-navigation__header__language-container__dropdown__button-container:hover
  .radio-button-custom {
  border-color: #999999;
}
.guestbook-navigation__header__language-container__dropdown__button-container
  .radio-button-custom__checkmark {
  display: none;
  width: 9px;
  height: 9px;
  border-radius: 50%;
}
.guestbook-navigation__header__language-container__dropdown__button-container
  input:checked
  ~ .radio-button-custom
  .radio-button-custom__checkmark {
  /* When input is checked, change sibling */
  display: block;
}
.guestbook-navigation__header__logo-container {
  padding: 5px 5px;
}
.guestbook-navigation__header__logo-container img {
  height: 100%;
}
.hamburger-icon {
  width: auto;
}
.hamburger-icon .hamburger-icon__bar {
  display: block;
  content: "";
  width: 25px;
  height: 2px;
}
.hamburger-icon .hamburger-icon__bar:first-child {
  margin-bottom: 5px;
}
.hamburger-icon .hamburger-icon__bar:last-child {
  margin-top: 5px;
}
.guestbook-navigation__navigation {
  position: relative;
  z-index: 5;
  background-color: white;
}
.guestbook-navigation__navigation__item {
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #dddddd;
  cursor: pointer;
}

@media screen and (min-width: 1040px) {
  .guestbook-navigation__header {
    justify-content: flex-end;
  }
  .guestbook-navigation__header__logo-container {
    margin-right: auto;
  }
  .guestbook-navigation__header__language-container,
  .guestbook-navigation__header__nav-button-container {
    order: 1;
  }
  .guestbook-navigation__navigation__wrapper {
    max-width: 1000px;
    display: flex;
    flex-direction: row;
    margin: 0 auto;
  }
  .guestbook-navigation__navigation__item {
    border-bottom: none;
    border-right: 1px solid #dddddd;
    padding: 0 20px;
    height: 50px;
    user-select: none;
  }
  .guestbook-navigation__navigation__item:first-child {
    border-left: 1px solid #dddddd;
  }
}
</style>
